const Module = () => import('./FoscModule.vue');

import { useAuthStore } from '@/stores/authStore';

const filterPath = (to, from, next) => {
  if (to.fullPath !== to.path) {
    to.meta.breadcrumb = setBreadcrumbs(to, from);
    next({ path: to.path });
  } else {
    to.meta.breadcrumb = setBreadcrumbs(to, from);
    next();
  }
};

const setBreadcrumbs = (to) => {
  let breadcrumbs = [];
  const authStore = useAuthStore();

  if (authStore.user.isAdminUser && to.name === 'foscannualreport') {
      breadcrumbs.push({ label: 'Review Annual Reports', route: '/program/annualreports' });
      breadcrumbs.push({ label: to.meta.title });
  } else {
    breadcrumbs = to.meta.breadcrumb;
  }

  return breadcrumbs;
};

const moduleRoutes = {
  path: '/fosc',
  component: Module,
  children: [
      {
          path: 'annualreport/:reportId',
          name: 'foscannualreport',
          props: true,
          meta: {
              title: 'Freestanding Outpatient Surgical Center Report',
              requiresAuth: true,
              breadcrumb: [
                  { label: 'Annual Reports', route: '/annualreports' },
                  { label: 'Freestanding Outpatient Surgical Center Report' }
              ]
          },
          component: () => import('./views/FoscReportView.vue'),
          beforeEnter: filterPath
      }
  ]
};

export default router => {
  router.addRoute(moduleRoutes);
};